import { __rest } from "tslib";
import { createElement, forwardRef } from 'rax';
import CircleProgress from './circle';
import LinearProgress from './linear';
const Progress = (_a, ref) => {
    var { shape = 'line' } = _a, others = __rest(_a, ["shape"]);
    return shape === 'line' ? <LinearProgress {...others} ref={ref}/> : <CircleProgress {...others} ref={ref}/>;
};
Progress.displayName = 'Progress';
export default forwardRef(Progress);
